export function detectFloatNumPrecision(num) {
  const str = `${num}`;
  if (str.includes('e')) {
    const separator = Math.abs(+str[str.length - 1]);
    const countOfAfterDotNums = str.slice(str.indexOf('.') + 1, str.indexOf('e')).length;
    return separator + countOfAfterDotNums;
  }
  if (!str.includes('.')) {
    return 0;
  }
  return str.slice(str.indexOf('.') + 1).length;
}
